module.exports = __webpack_public_path__ + "img/edit-icon.30e496d6.svg";